import * as React from "react";
import {Popover} from "@livingdesign/react";

export const QA_ID_PREFIX = `PopoverMessage`;

function PopoverMessage({
    disabled,
    children,
    content,
    position = "topCenter"
}) {
    const [state, setState] = React.useState(false);
    const ref = React.useRef();

    return (
        <>
        {disabled
            ?
            <Popover
                content={content}
                onClose={() => setState(false)}
                isOpen={state}
                triggerRef={ref}
                UNSAFE_style={{display: "block", position: 'relative'}}
                position={position}
                hasNubbin={true}
                data-testid={`${QA_ID_PREFIX}-popover`}
            >
                <>
                    <div
                        style={{
                            position: 'absolute',
                            height: '100%',
                            width: '100%',
                            top: 0,
                            left: 0,
                            zIndex: 1,
                        }}
                        ref={ref}
                        onClick={() => {
                            setState((state) => !state);
                        }}
                        data-testid={`${QA_ID_PREFIX}-trigger`}
                    >  
                    </div>
                    <div data-testid={`${QA_ID_PREFIX}-children-wrapper`}>
                        {children}
                    </div>
                </>
            </Popover>
            :
            <div data-testid={`${QA_ID_PREFIX}-children-disabled`}>
                {children}
            </div>
        }
        </>
    );
}

export default PopoverMessage;